import style from "./style.module.css";


import { useContext } from "react";
import StoreContext from "../../../../context/store";

import lectures from "../../../../assets/modalIcons/lectureinfo.svg"
import cross from "../../../../assets/modalIcons/cross.svg"

const NonPlaceModal = () => {

    const { setNonPlacedLecturesModal } =
        useContext(StoreContext);
    return (
        <div className={style.modal}>
            <div className={style.modalbox}>
                <div className={style.uppertabs}>
                    <div className={style.tableftside}>
                        <div className={style.tab}>
                            <button className={style.tabicon_left}>
                                <img alt="" src={lectures}></img>
                            </button>
                            <div className={style.tabtext_left}>Yerleşmeyen Dersler </div>
                        </div>
                    </div>
                    <div className={style.tabrightside}>
                        <div className={style.tab}>
                            <button className={style.tabicon_right} onClick={() => {
                                setNonPlacedLecturesModal(false);
                            }}>
                                <img alt="" src={cross}></img>
                            </button>
                            <div className={style.tabtext_right}>Kapat</div>
                        </div>
                    </div>
                </div>
                <div className={style.contents}>
                    
                </div>
                <div className={style.lowertabs}>
                    <div className={style.tableftside}></div>
                    <div className={style.tabrightside}>
                    
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NonPlaceModal;